import { useState } from "react";
import { FaMinus, FaPlus, FaRegTrashAlt, FaFilePdf, FaCertificate } from "react-icons/fa";
import { useTheme } from "../context/ThemeContext";
import { MdList } from "react-icons/md";
import { useOrderCrud } from "../context/OrderCrudContext";
import emptyImage from "../assets/empty.png";
import { downloadProductDoc } from "../util/downloadProductFile";

const ProductCard = ({ product, setDetailProduct, orderHasProduct, handleToggleVersion, indexInOrder, onChange, onRemove }) => {

    const { data } = useOrderCrud();

    const { background } = useTheme();

    const [downloadingType, setDownloadingType] = useState(null);

    const dataSheetUrl = product?.dataSheet || product?.data_sheet;
    const certificateUrl = product?.certificate;

    const handleDownloadDataSheet = async (e) => {
        e.stopPropagation();
        try {
            setDownloadingType('data_sheet');
            await downloadProductDoc(`/products/${product.id}/data-sheet/download`, `Ficha_Tecnica_${product.code || product.id}.pdf`);
        } catch (err) {
            console.error(err);
            alert("No se pudo descargar la ficha técnica");
        } finally {
            setDownloadingType(null);
        }
    };

    const handleDownloadCertificate = async (e) => {
        e.stopPropagation();
        try {
            setDownloadingType('certificate');
            await downloadProductDoc(`/products/${product.id}/certificate/download`, `Certificado_${product.code || product.id}.pdf`);
        } catch (err) {
            console.error(err);
            alert("No se pudo descargar el certificado");
        } finally {
            setDownloadingType(null);
        }
    };

    const handleMinus = () => {
        if (data?.orderItems?.[indexInOrder]?.quantity < 1) return;

        var value = data?.orderItems?.[indexInOrder]?.quantity ?? 0;
        value = value - 1;

        onChange({ target: { name: 'quantity', value } }, indexInOrder);
    }

    const handleAdd = () => {
        var value = data?.orderItems?.[indexInOrder]?.quantity ?? 0;
        value = value + 1;

        onChange({ target: { name: 'quantity', value } }, indexInOrder);
    }

    const handleChange = (e) => {
        onChange(e, indexInOrder);
    }

    return (
        <div className="col-md-2 mb-3">
            <div
                className="rounded mb-3 shadow position-relative product-card-container"
                style={{ overflow: 'hidden', background: background?.value === 'light' ? 'white' : '#171622' }}
            >
                {/* Badges superiores izquierda: Ficha técnica y Certificado rápidos */}
                <div className="position-absolute d-flex gap-1" style={{ top: 4, left: 4, zIndex: 2 }}>
                    {dataSheetUrl && (
                        <button
                            type="button"
                            onClick={handleDownloadDataSheet}
                            disabled={downloadingType === 'data_sheet'}
                            className="badge bg-danger text-white text-decoration-none shadow-sm border-0"
                            title="Descargar Ficha Técnica"
                            style={{ padding: '4px 6px', fontSize: '11px', cursor: 'pointer' }}
                        >
                            {downloadingType === 'data_sheet' ? (
                                <span className="spinner-border spinner-border-sm" style={{ width: '10px', height: '10px' }} />
                            ) : (
                                <FaFilePdf />
                            )}
                        </button>
                    )}
                    {certificateUrl && (
                        <button
                            type="button"
                            onClick={handleDownloadCertificate}
                            disabled={downloadingType === 'certificate'}
                            className="badge bg-info text-white text-decoration-none shadow-sm border-0"
                            title="Descargar Certificado"
                            style={{ padding: '4px 6px', fontSize: '11px', cursor: 'pointer' }}
                        >
                            {downloadingType === 'certificate' ? (
                                <span className="spinner-border spinner-border-sm" style={{ width: '10px', height: '10px' }} />
                            ) : (
                                <FaCertificate />
                            )}
                        </button>
                    )}
                </div>

                {
                    product?.children_count > 0 ?
                        <div className="text-center position-absolute" style={{ top: 0, right: 0, zIndex: 2 }}>
                            <button onClick={() => setDetailProduct(product)} className="badge badge-primary border-0" style={{ borderRadius: 0 }}>
                                <MdList size={23} />
                            </button>
                        </div>
                        :
                        null
                }
                <img
                    src={product?.image_path || emptyImage}
                    className="border-bottom border-primary"
                    alt=""
                    style={{ objectFit: 'cover', height: 120, width: '100%' }}
                    onError={(e) => {
                        // Evita que entre en un bucle si la imagen de error también falla
                        if (e.target.src !== 'https://csirindefondos.csiltda.cl/images/empty.png') {
                            e.target.onerror = null; // Desactiva el manejador después del primer error
                            e.target.src = 'https://csirindefondos.csiltda.cl/images/empty.png';
                        }
                    }}
                />
                <div className="p-1" style={{ position: 'relative' }}>
                    <div className="product-card-complete-name text-center position-absolute text-white bg-primary" style={{ width: '100%', left: 0, bottom: '100%' }}>
                        {product?.name}
                    </div>
                    <h6 title={product?.name} className="text-truncate mt-2 position-relative" style={{ width: '100%' }}>
                        {product?.name}
                    </h6>

                    <b className="text-primary">{product?.code}</b>
                    <div>
                        <b>{product?.category_name || ''}</b>
                    </div>

                    <div className="text-center mt-2 mb-3">
                        {
                            orderHasProduct ?
                                <div class="input-group">
                                    <button
                                        class="btn btn-sm btn-primary"
                                        style={{ padding: 5, height: 30 }}
                                        type="button"
                                        onClick={() => {
                                            if (data?.orderItems?.[indexInOrder]?.quantity < 2) {
                                                onRemove?.()
                                            } else {
                                                handleMinus?.();
                                            }
                                        }}
                                    >
                                        {
                                            data?.orderItems?.[indexInOrder]?.quantity < 2 ?
                                                <FaRegTrashAlt />
                                                :
                                                <FaMinus />
                                        }
                                    </button>
                                    <input
                                        value={data?.orderItems?.[indexInOrder]?.quantity}
                                        type="number"
                                        min={0}
                                        name="quantity"
                                        onChange={handleChange}
                                        class="form-control text-center"
                                        style={{ height: 30 }}
                                        placeholder="Cantidad"
                                    />
                                    <button
                                        class="btn btn-sm btn-primary"
                                        style={{ padding: 5, height: 30 }}
                                        type="button"
                                        onClick={handleAdd}
                                    >
                                        <FaPlus />
                                    </button>
                                </div>
                                :
                                <button
                                    onClick={() => handleToggleVersion(product)}
                                    className="btn btn-primary btn-xs"
                                    type="button"
                                >
                                    Agregar al carrito
                                </button>
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ProductCard;